import React from 'react';
import Loading from "../components/Loading";

function LoadingPage(props) {
    return (
        <div style={{width: '100%'}}>
            <Loading/>
        </div>
    );
}

export default LoadingPage;